<template>
  <section class="dflexc-jcs merchant-item-table">
    <div class="merch-table-header">
      Merchant items for sale
    </div>
    <div class="dflexr-jcs item-card"
         :class="cardClass"
         >
      <div class="merchant-table" v-for="item in items_for_sale">
        <div class="eq-items" v-if="eqType">
          <div class="equipment-text" v-if="item.txt_only">
            {{ item.txt_only }}
          </div>
        </div>

        <div class="eq-items" v-if="sgType">
          <div class="sage-text" v-if="item.txt_only">
            {{ item.txt_only }}
          </div>
        </div>

        <div class="ht-items" v-if="type === 'Ht'">
          Horses available
          <div class="dflexr-jcsa">
            <div class="lt-horse" >
              Lt: {{ item.lt }}
            </div>
            <div class="md-horse" >
              Md: {{ item.md }}
            </div>
            <div class="hv-horse" >
              Hv: {{ item.hv }}
            </div>
          </div>
        </div>
      </div>


      <div class="dflexr-jcs flexwrap-on al-items" v-if="type === 'Al'" >
        <div class="al-item" v-for="item in items_for_sale" :key="item" >
          {{ item }}
        </div>
      </div>

      <div class="mg-items" v-if="type === 'Mg'" >
        <div class="mg-item" v-for="item in items_for_sale" :key="item" >
          {{ item }}
        </div>
      </div>

      <div class="sl-items" v-if="type === 'Sl'" >
        <div class="beauty-lbl">
          Slave Beauty
        </div>
        <div class="sl-item" v-for="sl in items_for_sale" :key="sl" >
          {{ sl }}
        </div>
      </div>

      <div class="jw-items" v-if="type === 'Jw'" >
        <div class="jewels-lbl">
          Jewels available
        </div>
        <div class="Jw-item" v-for="jw in items_for_sale" :key="jw" >
          {{ jw }}
        </div>
      </div>

    </div>
  </section>
  <div class="dflexc-jcs dlg-purchase-item"
    v-if="show_buy_dialog"
  >
    <div class="buy-dlg-header">
      {{ buy_header }}
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/marketplace/sm.scss";
@import "@/assets/styles/marketplace/md.scss";
@import "@/assets/styles/marketplace/lg.scss";
@import "@/assets/styles/marketplace/xl.scss";

</style>

<script setup>

import {computed, onUpdated, ref} from "vue";

const props = defineProps(['merchant'])
const show_buy_dialog = ref(false)
const buy_header = ref('')
const buy_str = ref('')

const eqType = computed(() => {
  return props.merchant.type === 'Eq'
})
const sgType = computed(() => {
  return props.merchant.type === 'Sg'
})
const htType = computed(() => {
  return props.merchant.type === 'Ht'
})
const alType = computed(() => {
  return props.merchant.type === 'Al'
})
const mgType = computed(() => {
  return props.merchant.type === 'Mg'
})
const slType = computed(() => {
  return props.merchant.type === 'Sl'
})

// Single source of truth for merchant type
const type = computed(() => props.merchant?.type ?? '')

// Optional: centralize the card classes
const cardClass = computed(() => ({
  'eq-card': type.value === 'Eq',
  'sg-card': type.value === 'Sg',
  'ht-card': type.value === 'Ht',
  'al-card': type.value === 'Al',
  'mg-card': type.value === 'Mg',
  'sl-card': type.value === 'Sl',
  'jw-card': type.value === 'Jw',
}))

const items_for_sale = computed(() => {
  const items = []

  if(type.value === 'Eq') {
    items.push({
      txt_only: "See Ironhedge rulebook page 7"
    })
  }

  if(type.value === 'Sg') {
    items.push({
      txt_only: `Is ${props.merchant.preach} preaching.`
    })
  }

  if(type.value === 'Ht') {
    let numHorse = props.merchant.numHorses
    let horses = { lt: 0, md: 0, hv: 0}
    for(let i = 0; i < numHorse; i++) {
      const x = Math.floor(Math.random() * (97 - 21 + 1)) + 21
      if(x > 20 && x < 51)
        horses.lt++
      else if(x > 50 && x < 75)
        horses.md++
      else
        horses.hv++
    }
    items.push(horses)
  }

  if(type.value === 'Al') {

    for(const item of props.merchant.items) {
      items.push(`${item.name}(${item.dose})`)
    }
  }

  if(type.value === 'Mg') {
    for(const item of props.merchant.items) {
      items.push(`${item.strval}`)
    }
    console.log('items', items)
  }

  if(type.value === 'Sl') {
    console.log('slaver obj:', props.merchant)
    for(const sl of props.merchant.slaves) {
      items.push(`${sl}`)
    }
  }

  if(type.value === 'Jw') {
    console.log('Jeweler:', props.merchant)
    for(const jw of props.merchant.jewels_list) {
      items.push(`${jw}`)
    }
  }

  return items
})

onUpdated(() => {
})


</script>
